import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Khai báo đủ 40 mã ngôn ngữ theo national market.
const supportedLanguages = [
  'en', 'vi', 'hi', 'zhs', 'zht', 'es', 'ar', 'fr', 'bn', 'pt',
  'ru', 'ur', 'id', 'de', 'ja', 'mr', 'tr', 'sw', 'ha', 'fil',
  'ko', 'fa', 'pa', 'am', 'th', 'jv', 'it', 'yo', 'ms', 'pl',
  'uk', 'nl', 'ps', 'ro', 'my', 'om', 'so', 'ne', 'az', 'mg',
];

const resources = Object.fromEntries(
  supportedLanguages.map((code) => [code, { translation: {} }])
);

// Khởi tạo i18next
i18n
  .use(initReactI18next) // Kết nối với react-i18next
  .init({
    resources,
    lng: 'en',            // Ngôn ngữ mặc định
    fallbackLng: 'vi',    // Ngôn ngữ dự phòng
    interpolation: {
      escapeValue: false  // React đã tự escape
    }
  });

export default i18n;
